import { useEffect, useState } from "react";

/**
 * Unified GAS loader:
 * - schedule (+ upcoming/results subsets)
 * - standings (Prem/Div)
 * - top scorers / assisters (Prem/Div)
 *
 * Expects Apps Script routes:
 *   route=schedule | schedule_upcoming | schedule_results | standings | top_scorers | top_assisters
 * Optional &league=Prem|Div
 */
export function useGasApi(baseUrl, key) {
  const [state, setState] = useState({
    schedule: [],
    upcoming: [],
    results: [],
    standingsPrem: [],
    standingsDiv: [],
    scorersPrem: [],
    scorersDiv: [],
    assistersPrem: [],
    assistersDiv: [],
    loading: true,
    error: null,
  });

  useEffect(() => {
    let alive = true;

    const GET = (route, league) =>
      fetch(
        `${baseUrl}?route=${encodeURIComponent(route)}${
          league ? `&league=${encodeURIComponent(league)}` : ""
        }&key=${encodeURIComponent(key)}`
      ).then((r) => {
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        return r.json();
      });

    async function run() {
      try {
        const [
          scheduleAll,
          upcomingAll,
          resultsAll,
          standingsPrem,
          standingsDiv,
          scorersPrem,
          scorersDiv,
          assistersPrem,
          assistersDiv,
        ] = await Promise.all([
          GET("schedule"),
          GET("schedule_upcoming"),
          GET("schedule_results"),
          GET("standings", "Prem"),
          GET("standings", "Div"),
          GET("top_scorers", "Prem"),
          GET("top_scorers", "Div"),
          GET("top_assisters", "Prem"),
          GET("top_assisters", "Div"),
        ]);

        if (!alive) return;
        setState({
          schedule: scheduleAll || [],
          upcoming: upcomingAll || [],
          results: resultsAll || [],
          standingsPrem: standingsPrem || [],
          standingsDiv: standingsDiv || [],
          scorersPrem: scorersPrem || [],
          scorersDiv: scorersDiv || [],
          assistersPrem: assistersPrem || [],
          assistersDiv: assistersDiv || [],
          loading: false,
          error: null,
        });
      } catch (err) {
        if (alive)
          setState((s) => ({ ...s, loading: false, error: err?.message || "error" }));
      }
    }

    run();
    return () => {
      alive = false;
    };
  }, [baseUrl, key]);

  return state;
}
